import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../store';

export const selectElementState = (state: RootState) => state.element;

export const selectContentDiv = createSelector(
  selectElementState,
  (state) => state.contentDiv.value
);

export const selectProduct = createSelector(selectElementState, (state) => state.product.value);

export const selectProductLoading = createSelector(
  selectElementState,
  (state) => state.product.loading
);

export const selectProductLoaded = createSelector(
  selectElementState,
  (state) => state.product.loaded
);

export const selectProductError = createSelector(
  selectElementState,
  (state) => state.product.error
);
